var TEMPLATE_URL = require('./breadcrumb.html');
angular.module('ikeweb.spike.step').directive('ikeBreadcrumb',
    function() {
        return {
            scope: {
                capture: '=',
                changeStep: '=?'
            },
            templateUrl: TEMPLATE_URL,
            controller: 'BreadcrumbController',
            controllerAs: 'ctrl',
            bindToController: true,
            replace: true
        };
    }
);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/spike/step/breadcrumb/breadcrumb.directive.js
// module id = 598
// module chunks = 0